require('./wahanda/base.js');
require('./wahanda/analytics.js');
false
require('./wahanda/appointment.js');
// require('./wahanda/base.js'); is duplicative.
require('./wahanda/comparators.js');
require('./wahanda/currency.js');
require('./wahanda/customer-contact-showing-check.js');
require('./wahanda/date.js');
require('./wahanda/debug-bar.js');
require('./wahanda/device.js');
require('./wahanda/dialogs.js');
require('./wahanda/discount-calculator.js');
require('./wahanda/error-report.js');
require('./wahanda/es6bridge.js');
require('./wahanda/event.js');
require('./wahanda/features.js');
require('./wahanda/form.js');
require('./wahanda/initial-generator.js');
require('./wahanda/link.js');
// false is duplicative.
require('./wahanda/localStorage.js');
require('./wahanda/media-query.js');
require('./wahanda/number.js');
require('./wahanda/page.js');
require('./wahanda/permissions.js');
require('./wahanda/platform.js');
require('./wahanda/screen-density.js');
require('./wahanda/sessionReplay.js');
require('./wahanda/shortcuts.js');
require('./wahanda/template.js');
require('./wahanda/text.js');
require('./wahanda/time-profiler.js');
require('./wahanda/time.js');
require('./wahanda/toastNotifications.js');
require('./wahanda/url.js');
require('./wahanda/util.js');
require('./wahanda/validate.js');
require('./wahanda/wizzard.js');

